import React, { ReactNode } from 'react';

import { useRouterLocation } from 'components/hooks';
import { WelcomeCodeRequiredModal } from 'components/rewards/referral/WelcomeCodeRequiredModal';
import { TESTNET_SANDBOX_WELCOME_ENABLED } from 'components/rewards/testnetSandbox/constants';
import { SandboxTestnetWelcome } from 'components/rewards/testnetSandbox/SandboxTestnetWelcome';
// import { isDashboardPath } from 'components/trading/dashboardDetect';
import { isDashboardPath } from 'components/trading/dashboardDetect';
import { CODE_REQUIRED_OVERLAY } from 'config/constants';
import { useIsMobile } from 'hooks/useIsMobile';
import { useSelector } from 'reduxState/storeCore';

import MainLayoutDesktop from './MainLayoutDesktop';
import MainLayoutMobile from './MainLayoutMobile';

type Props = {
  children: ReactNode;
};

function MainLayout({ children }: Props) {
  const isMobile = useIsMobile();
  const walletAddress = useSelector(state => state.wallet.walletAddress);
  // const closedWelcomeModal = useSelector(
  //   state => state.exchange.userGuide.closedWelcomeModal
  // );
  const location = useRouterLocation();
  const isScrollableDashboard = isDashboardPath(location.pathname);
  //   location.pathname.startsWith('/wallet');

  if (
    isMobile &&
    !walletAddress &&
    TESTNET_SANDBOX_WELCOME_ENABLED &&
    location.pathname !== '/katana-connect'
  ) {
    // No need to render anything else on mobile
    return <SandboxTestnetWelcome />;
  }

  // if (isMobile && !closedWelcomeModal) {
  //   return <WelcomeModal />;
  // }

  return isMobile ? (
    <MainLayoutMobile>
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
      />
      {isMobile && !walletAddress && CODE_REQUIRED_OVERLAY && (
        <WelcomeCodeRequiredModal />
      )}
      {children}
    </MainLayoutMobile>
  ) : (
    <MainLayoutDesktop isScrollable={isScrollableDashboard}>
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      {!walletAddress && TESTNET_SANDBOX_WELCOME_ENABLED && (
        <SandboxTestnetWelcome />
      )}
      {!walletAddress &&
        !TESTNET_SANDBOX_WELCOME_ENABLED &&
        CODE_REQUIRED_OVERLAY && <WelcomeCodeRequiredModal />}

      {/* {!closedWelcomeModal && <WelcomeModal />} */}
      {children}
    </MainLayoutDesktop>
  );
}

export default MainLayout;
